import { $channels } from '@/ts/store';
import './_hero-banner-animation.scss';
import Splide from '@splidejs/splide';
import { bindCarousel } from '@/ts/utilities';
import { AV_LANGUAGES } from '@/ts/enums';

/*
 * Init Hero Banner Animation component and enable better accessibility features.
 * */

export default function HeroBannerAnimation() {
    const $heroBanners = document.querySelectorAll('.hero-banner-animation');

    if ($heroBanners) {
        $heroBanners.forEach(($heroBanner: any, index: number) => {
            const $buttons = $heroBanner.querySelectorAll('button.show-details');
            const $wrapper = $heroBanner.querySelector('.wrapper') as HTMLDivElement;
            const $activeAnimation = $heroBanner.querySelector('.animation-btn .animation.active') as HTMLDivElement;
            const $inactiveAnimation = $heroBanner.querySelector('.animation-btn .animation.inactive') as HTMLDivElement;
            const $activeAnimationMob = $heroBanner.querySelector('.animation-btn.mobile .animation.active') as HTMLDivElement;
            const $inactiveAnimationMob = $heroBanner.querySelector('.animation-btn.mobile .animation.inactive') as HTMLDivElement;
            const $arrows = $heroBanner.querySelectorAll('.arrow.next-paragraph');
            const $paragraphs = document.querySelectorAll('article .paragraph');
            const $target = $heroBanner.querySelector('[data-webgl="mountainScene"]');
            //@ts-ignore;
            const htmlLang: any = (document.querySelector('html') as HTMLElement) ? document.querySelector('html').getAttribute('lang') : '';
            const currentLanguage: any = htmlLang && AV_LANGUAGES.find(lang => lang.includes(htmlLang)) ? AV_LANGUAGES.find(lang => lang.includes(htmlLang)) : 'en-GB';

            function openPoints($button: HTMLElement, indexPoint: number) {
                const buttonId = $button.getAttribute('data-button-id');
                const $points = $heroBanner.querySelectorAll('.point');
                const $pointVisible = $heroBanner.querySelector('.point.visible');

                $points.forEach(($point: any) => {
                    const $subtitle = $point.querySelector('.subtitle') as HTMLElement;
                    const $title = $point.querySelector('.title') as HTMLElement;
                    const $description = $point.querySelector('.description') as HTMLElement;
                    const $link = $point.querySelector('.item-link') as HTMLAnchorElement;

                    const pointDataId = $point.getAttribute('data-id');
                    if ($pointVisible) {
                        const $links = $pointVisible.querySelectorAll('a');
                        if ($pointVisible.getAttribute('data-id') !== buttonId) {
                            switch (indexPoint) {
                                case 0:
                                    $target.dispatchEvent(new Event('morphLeft'));
                                    break;

                                case 1:
                                    $target.dispatchEvent(new Event('morphCenter'));
                                    break;

                                default:
                                    $target.dispatchEvent(new Event('morphRight'));
                                    break;
                            }
                            $pointVisible.querySelector('button').setAttribute('aria-expanded', 'false');
                            $pointVisible.classList.remove('visible');
                            $pointVisible.classList.add('close');
                            $subtitle?.setAttribute('aria-hidden', 'true');
                            $description?.setAttribute('aria-hidden', 'true');
                            $link?.setAttribute('aria-hidden', 'true');
                            if ($links.length) {
                                $links.forEach(($el: any) => {
                                    $el.setAttribute('tabindex', '-1');
                                });
                            }
                            $heroBanner.classList.remove(`data-${pointDataId}`);

                            $point.classList.add('temp');

                            $title.onanimationend = () => {
                                $point.classList.remove('temp');
                            };

                            if (pointDataId && pointDataId === buttonId) {
                                const $links = $point.querySelectorAll('a');
                                $point.classList.remove('not-animation');
                                $point.classList.remove('small');
                                $point.classList.add('visible');
                                $point.querySelector('button').setAttribute('aria-expanded', 'true');
                                $point.classList.remove('close');
                                $subtitle?.removeAttribute('aria-hidden');
                                $description?.removeAttribute('aria-hidden');
                                $link?.removeAttribute('aria-hidden');
                                if ($links.length) {
                                    $links.forEach(($el: any) => {
                                        $el.setAttribute('tabindex', '0');
                                    });
                                }
                                $heroBanner.classList.add(`data-${pointDataId}`);
                            }
                        } else {
                            $target.dispatchEvent(new Event('morphRest'));
                            $pointVisible.classList.remove('visible');
                            $pointVisible.querySelector('button').setAttribute('aria-expanded', 'false');
                            $pointVisible.classList.add('close');
                            $subtitle?.setAttribute('aria-hidden', 'true');
                            $description?.setAttribute('aria-hidden', 'true');
                            $link?.setAttribute('aria-hidden', 'true');
                            if ($links.length) {
                                $links.forEach(($el: any) => {
                                    $el.setAttribute('tabindex', '-1');
                                });
                            }
                            $wrapper.classList.remove('point-open');
                            $heroBanner.classList.remove(`data-${pointDataId}`);
                        }
                    } else {
                        switch (indexPoint) {
                            case 0:
                                $target.dispatchEvent(new Event('morphLeft'));
                                break;

                            case 1:
                                $target.dispatchEvent(new Event('morphCenter'));
                                break;

                            default:
                                $target.dispatchEvent(new Event('morphRight'));
                                break;
                        }
                        if (pointDataId && pointDataId === buttonId) {
                            const $links = $point.querySelectorAll('a');
                            $point.classList.remove('not-animation');
                            $wrapper.classList.add('point-open');
                            $point.querySelector('button').setAttribute('aria-expanded', 'true');
                            $point.classList.add('visible');
                            $point.classList.remove('close');
                            $subtitle?.removeAttribute('aria-hidden');
                            $description?.removeAttribute('aria-hidden');
                            $link?.removeAttribute('aria-hidden');
                            if ($links.length) {
                                $links.forEach(($el: any) => {
                                    $el.setAttribute('tabindex', '0');
                                });
                            }
                            $heroBanner.classList.add(`data-${pointDataId}`);
                        } else {
                            $point.classList.add('temp');

                            $title.onanimationend = () => {
                                $point.classList.remove('temp');
                            };
                        }
                    }
                });
            }

            function disableAnimation() {
                if ($activeAnimation && $activeAnimationMob) {
                    $activeAnimation.addEventListener('click', () => {
                        $activeAnimation.classList.add('d-none');
                        $inactiveAnimation.classList.remove('d-none');
                        $heroBanner.classList.add('no-animation');
                    });

                    $activeAnimation.addEventListener('keypress', e => {
                        if (e.key === 'Enter') {
                            $activeAnimation.classList.add('d-none');
                            $inactiveAnimation.classList.remove('d-none');
                            $heroBanner.classList.add('no-animation');
                        }
                    });

                    $activeAnimationMob.addEventListener('click', () => {
                        $activeAnimationMob.classList.add('d-none');
                        $inactiveAnimationMob.classList.remove('d-none');
                        $heroBanner.classList.add('no-animation');
                    });

                    $activeAnimationMob.addEventListener('keypress', e => {
                        if (e.key === 'Enter') {
                            $activeAnimationMob.classList.add('d-none');
                            $inactiveAnimationMob.classList.remove('d-none');
                            $heroBanner.classList.add('no-animation');
                        }
                    });
                }
            }

            function enableAnimation() {
                if ($inactiveAnimation && $inactiveAnimationMob) {
                    $inactiveAnimation.addEventListener('click', () => {
                        $inactiveAnimation.classList.add('d-none');
                        $activeAnimation.classList.remove('d-none');
                        $heroBanner.classList.remove('no-animation');
                    });

                    $inactiveAnimation.addEventListener('keypress', e => {
                        if (e.key === 'Enter') {
                            $inactiveAnimation.classList.add('d-none');
                            $activeAnimation.classList.remove('d-none');
                            $heroBanner.classList.remove('no-animation');
                        }
                    });

                    $inactiveAnimationMob.addEventListener('click', () => {
                        $inactiveAnimationMob.classList.add('d-none');
                        $activeAnimationMob.classList.remove('d-none');
                        $heroBanner.classList.remove('no-animation');
                    });

                    $inactiveAnimationMob.addEventListener('keypress', e => {
                        if (e.key === 'Enter') {
                            $inactiveAnimationMob.classList.add('d-none');
                            $activeAnimationMob.classList.remove('d-none');
                            $heroBanner.classList.remove('no-animation');
                        }
                    });
                }
            }

            function scrollToNextParagraph() {
                $arrows.forEach(($arrow: HTMLElement) => {
                    $arrow.onclick = () => {
                        if ($paragraphs.length && $paragraphs[index + 1]) {
                            window.scroll({
                                top: ($paragraphs[index + 1] as HTMLDivElement).offsetTop - 100,
                                behavior: 'smooth',
                            });
                        }
                    };

                    $arrow.onkeyup = (e: KeyboardEvent) => {
                        if (e.key === 'Enter') {
                            if ($paragraphs.length && $paragraphs[index + 1]) {
                                window.scroll({
                                    top: ($paragraphs[index + 1] as HTMLDivElement).offsetTop - 100,
                                    behavior: 'smooth',
                                });
                            }
                        }
                    };
                });
            }

            function initCarousel() {
                const $slide = $heroBanner.querySelector('.splide') as HTMLDivElement;

                if ($slide) {
                    //@ts-ignore
                    const $splide = new Splide($slide, {
                        type: 'slide',
                        autoplay: false,
                        perPage: 2,
                        perMove: 2,
                        pagination: true,
                        destroy: true,
                        breakpoints: {
                            991: {
                                perPage: 1,
                                perMove: 1,
                                pagination: true,
                                arrows: true,
                                gap: 24,
                                destroy: false,
                            },
                        },
                        i18n: {
                            prev: currentLanguage === 'it-IT' ? 'Slide precedente' : 'Previous slide',
                            next: currentLanguage === 'it-IT' ? 'Slide successiva' : 'Next slide',
                            slideLabel: currentLanguage === 'it-IT' ? '%s di %s' : '%s of %s',
                            slideX: currentLanguage === 'it-IT' ? 'Vai alla slide %s' : 'Go to slide %s',
                            select: currentLanguage === 'it-IT' ? 'Seleziona la slide da visualizzare' : 'Select a slide to show'
                        },
                    });
                    $splide.mount({}, bindCarousel);

                    $splide.on('move', e => {
                        $heroBanner.classList.remove('data-point-1');
                        $heroBanner.classList.remove('data-point-2');
                        $heroBanner.classList.remove('data-point-3');
                        if (e || e === 0) {
                            if(e){
                                $heroBanner.classList.add(`data-point-${e}`);
                            }

                            switch (e) {
                                case 0:
                                    $target.dispatchEvent(new Event('morphRest'));
                                    break;

                                case 1:
                                    $target.dispatchEvent(new Event('morphLeft'));
                                    break;

                                case 2:
                                    $target.dispatchEvent(new Event('morphCenter'));
                                    break;

                                default:
                                    $target.dispatchEvent(new Event('morphRight'));
                                    break;
                            }
                        }
                    });
                }
            }

            function init() {
                disableAnimation();
                enableAnimation();
                scrollToNextParagraph();
                initCarousel();

                const $carouselButtons = $heroBanner.querySelectorAll('.splide__pagination__page');
                const $titleSlide = $heroBanner.querySelectorAll('.splide__slide .title h3');
                if ($carouselButtons.length) {
                    $carouselButtons.forEach(($btn: any, i: number) => {
                        $btn.setAttribute('tabindex', '0');
                        $btn.setAttribute('aria-label', $titleSlide[i]?.innerText);
                    });
                }

                if ($buttons.length) {
                    $buttons.forEach(($button: HTMLElement, index: number) => {
                        $button.onclick = () => {
                            openPoints($button, index);
                        };

                        $button.addEventListener('keydown', (e: KeyboardEvent) => {
                            if (e.key === 'Enter') {
                                e.preventDefault();
                                openPoints($button, index);
                            }
                        });
                    });
                }
            }

            init();
        });
    }
}
